var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToReg24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4997 7.75098C15.4995 9.96098 13.7093 11.7508 11.4993 11.7507C9.28934 11.7505 7.49949 9.96033 7.49967 7.75033C7.49985 5.54033 9.29 3.75047 11.5 3.75066C13.71 3.75084 15.4999 5.54098 15.4997 7.75098ZM13.4997 7.75082C13.4998 6.65082 12.5998 5.75075 11.4998 5.75066C10.3998 5.75057 9.49976 6.65049 9.49967 7.75049C9.49958 8.85049 10.3995 9.75057 11.4995 9.75066C12.5995 9.75075 13.4996 8.85082 13.4997 7.75082ZM5.49885 17.7502C5.6989 17.1202 8.06899 16.0704 10.459 15.8106L12.4992 13.8107C12.1092 13.7707 11.8192 13.7507 11.4992 13.7507C8.82918 13.7504 3.49907 15.09 3.49885 17.75L3.49869 19.75L12.4987 19.7507L10.4989 17.7506L5.49885 17.7502ZM15.9689 17.421L21.0993 12.2514L22.4992 13.6616L15.9686 20.251L12.4989 16.7507L13.899 15.3409L15.9689 17.421Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToReg24Px);
export default __webpack_public_path__ + "static/media/how_to_reg_24px.0874f6ac14276d0f7ef3dfbc0a311026.svg";
export { ForwardRef as ReactComponent };